import * as store from './store'
import { setViewportHeight, viewportAdjust } from './modules/oreFunc'
import { instances } from './store'
import isMobile from 'ismobilejs'
import Loading from './modules/Loading'
import Modal from './modules/Modal'
import MovieBg from './modules/MovieBg'
import SmoothScroll from './modules/SmoothScroll'

import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger);

const loading = new Loading()
store.instances.smoothScroll = new SmoothScroll()
const locationHash = location.hash
const modal = new Modal();

if (document.body.classList.contains('home')) {
  // const globalHeader = new GlobalHeader()
}

/**
 * @type {number}
 */
store.instances.scrollOffset = isMobile(window.navigator).any ? 34 : 70

/**
 * ローディングチェック
 * @checkLoade
 */
const checkLoad = new Promise((resolve) => {
  loading.on('loaded', () => {
    resolve('load')
  })
})

/**
 * アップデート
 * @returns {void}
 */
function update() {
  // CSS変数 --dvhセット（dvhフォールバック）
  setViewportHeight()
}

/**
 * @returns {void}
 */


const init = () => {
  console.log('\u001b[32m' + 'init' + '\u001b[0m')
  viewportAdjust() // min375px
  update()

  Promise.all([checkLoad]).then((message) => {
    if (!store.instances.loading) {
      store.instances.loading = true
      console.log('\u001b[32m' + 'loaded!' + '\u001b[0m')
    }
    update()
    window.addEventListener('resize', () => {
      update()
    })

    if (locationHash) {
      window.scrollTo(0, 0)
    }
    document.body.classList.remove('now-loading')
  })
}

window.addEventListener('DOMContentLoaded', () => {
  init()

  ScrollTrigger.create({
    trigger: ".intro__package",
    // markers: true,
    start: "top 80%",
    toggleClass: {
      targets: ".intro__package",
      className: "is-animation"
    },
    once: true,
  });

  gsap.utils.toArray('.js-inView').forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      // markers: true,
      start: "top 80%",
      toggleClass: {
        targets: el,
        className: "is-show"
      },
      once: true,
    });
  })

})

const movieBg = new MovieBg()
